import React from 'react';
import { AddCartIcon as StyledAddCartIcon } from './AddCartButtonContainer.styled';

const AddCartIcon = ({
    mobilePath,
    width = '14px',
    height = '14px',
    mbWidth,
    mbHeight,
    marginLeft,
    alt = 'Cart icon',
    onClick,
    className,
    style,
    ...rest
}) => {

    if (!mobilePath) {
        return null;
    }

    return (
        <StyledAddCartIcon
            mobilePath={mobilePath}
            width={width}
            height={height}
            mbWidth={mbWidth}
            mbHeight={mbHeight}
            marginLeft={marginLeft}
            alt={alt}
            onClick={onClick}
            className={className}
            style={style}
            {...rest}
        />
    );
};

AddCartIcon.defaultProps = {
    width: '14px',
    height: '14px',
    alt: 'Cart icon',
};

export default AddCartIcon;